import { render, staticRenderFns } from "./socializationInfo.vue?vue&type=template&id=e290b2ea&scoped=true"
import script from "./socializationInfo.vue?vue&type=script&lang=js"
export * from "./socializationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e290b2ea",
  null
  
)

export default component.exports